import useTreeSelectCtrl from '@/shared/Tree/ctrl/useTreeSelectCtrl.ts'
import { IPassportGroup, IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import usePassportSchema from '@/pages/MDM/hooks/usePassprotSchema.ts'
import { ITreeGroup } from '@/shared/Tree/tree.types.ts'
import { useMemo } from 'react'
import DefaultTreeGroup from '@/shared/Tree/ui/DefaultTreeGroup'
import defaultTreeGroupStyling from '@/shared/Tree/ui/DefaultTreeGroup/defaultTreeGroup.styling.ts'
import Tree from '@/shared/Tree'

interface IProps {
  selectCtrl: ReturnType<typeof useTreeSelectCtrl>
  passportSchemaId: IPassportSchema['id']
  handleSelect?: (item: string | number) => void
  visibleGroups?: IPassportGroup['id'][]
}

const EquipmentPassportTree = (props: IProps) => {
  const schema = usePassportSchema(props.passportSchemaId)
  const treeGroups: ITreeGroup<IPassportGroup, number>[] = useMemo(() => {
    if (!schema || !schema.groups.length) return []
    const res: ITreeGroup<IPassportGroup, number>[] = schema.groups.map((g) => ({
      id: g.id,
      parentId: g.parentId,
      data: g,
      type: 'list-values',
    }))

    if (!props.visibleGroups) return res
    const visibleGroupsSet = new Set(props.visibleGroups)
    return res.filter((item) => visibleGroupsSet.has(item.id))
  }, [schema?.groups, props.visibleGroups])

  const renderGroup = (group: ITreeGroup<IPassportGroup, number>) => {
    return <DefaultTreeGroup key={group.id} title={group.data.name} group={group.data} />
  }

  return (
    <Tree
      leafs={[]}
      groups={treeGroups}
      renderGroup={renderGroup}
      renderLeaf={null}
      styling={{ groupClassname: defaultTreeGroupStyling.groupClassname }}
      selectCtrl={props.selectCtrl}
      onClickGroup={(group: Record<string, any>) => props?.handleSelect(group.id)}
    />
  )
}

export default EquipmentPassportTree
